"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.TransferTemplateAPI = {
    getTransferTemplates: function (companyId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/transferTemplates").then(function (response) {
            var transferTemplates = response.data.data;
            return transferTemplates;
        });
    },
    getTransferTemplateById: function (companyId, transferTemplateId) {
        return index_1.axios.get("/api/v1/company/" + companyId + "/transferTemplates/" + transferTemplateId).then(function (response) {
            var transferTemplate = response.data;
            return transferTemplate;
        });
    },
    createTransferTemplate: function (companyId, createObject) {
        return index_1.axios.post("/api/v1/company/" + companyId + "/transferTemplates", createObject).then(function (response) {
            var transferTemplate = response.data;
            return transferTemplate;
        });
    },
    updateTransferTemplate: function (companyId, transferTemplateId, updateObject) {
        return index_1.axios.put("/api/v1/company/" + companyId + "/transferTemplates/" + transferTemplateId, updateObject).then(function (response) {
            var transferTemplate = response.data;
            return transferTemplate;
        });
    },
};
//# sourceMappingURL=TransferTemplateAPI.js.map